// FWSD-5071
export const isCustomUserPermissions = (userRole, userPermissions, permissionType) => {
	if (['custom_user', 'custom_partner'].includes(userRole)) {
		if (!userPermissions || !permissionType) {
			return false
		}

		switch (permissionType) {
			case 'settings_profile_view':
				return userPermissions.find(({ perm_category_id, a_view, a_add, a_edit, a_delete }) => perm_category_id === 15 && (a_view || a_add || a_edit || a_delete))
			case 'settings_profile_add':
				return userPermissions.find(({ perm_category_id, a_add, a_edit, a_delete }) => perm_category_id === 15 && (a_add || a_edit || a_delete))
			case 'settings_profile_edit':
				return userPermissions.find(({ perm_category_id, a_edit, a_delete }) => perm_category_id === 15 && (a_edit || a_delete))
			case 'settings_profile_delete':
				return userPermissions.find(({ perm_category_id, a_delete }) => perm_category_id === 15 && a_delete)
			case 'user_add':
				return userPermissions.find(({ perm_category_id, a_add, a_edit, a_delete }) => perm_category_id === 16 && (a_add || a_edit || a_delete))
			case 'user_edit':
				return userPermissions.find(({ perm_category_id, a_edit, a_delete }) => perm_category_id === 16 && (a_edit || a_delete))
			case 'user_delete':
				return userPermissions.find(({ perm_category_id, a_delete }) => perm_category_id === 16 && (a_delete))
			case 'vehicle_edit':
				return userPermissions.find(({ perm_category_id, a_edit, a_delete }) => perm_category_id === 5 && (a_edit || a_delete))
			case 'settings_profile_disabledBtn':
				return !(_.find(userPermissions.filter(e => e.perm_category_name !== 'Other'), { a_view: true }).perm_category_id === 15)
			case 'event_feedback_add':
				return userPermissions.find(({ perm_category_id, a_add }) => perm_category_id === 18 && (a_add))
			case 'event_feedback_edit':
				return userPermissions.find(({ perm_category_id, a_edit }) => perm_category_id === 18 && (a_edit))
		}

		return false
	}

	return true
}

export const CHANNELS_LIST = [1, 2, 3, 4]

export const getUserChannelsAccess = (user) => (
	['custom_user', 'custom_partner'].includes(user?.roles?.[0]) && user.channels_access
		? `${user.channels_access}`.split(',').map(Number).filter(channel => CHANNELS_LIST.includes(channel))
		: null
)

export const isChannelAccessible = (user, channel) => {
	const channelsAccess = getUserChannelsAccess(user)
	return !channelsAccess || channelsAccess.includes(+channel)
}

export const hasChannelsRestriction = (user) => (getUserChannelsAccess(user) || CHANNELS_LIST).length < CHANNELS_LIST.length

export const filterDeviceChannelsAccess = (user, device) => (
	device && getUserChannelsAccess(user)
		? {
			...device,
			channel_available: device.channel_available && `${device.channel_available}`.split(',').filter(channel => isChannelAccessible(user, channel)).join(','),
			channel_status: device.channel_status?.filter?.(({ channel }) => isChannelAccessible(user, channel)) || device.channel_status,
		}
		: device
)

const getChannelFromUrl = (url) => {
	const match = `${url || ''}`.split('?')[0].match(/[_/]([1-4])\.[a-z0-9]+$/i)
	return match ? +match[1] : null
}

export const filterUrlsByChannelsAccess = (user, urls) => (urls || []).filter(url => isChannelAccessible(user, getChannelFromUrl(url)))

export const getUrlsChannels = (urls) => (urls || []).map((url, index) => getChannelFromUrl(url) || index + 1)
